import React, {useState, useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import Clock from 'react-live-clock'
import { Icon, Label, Popup, Modal, Button, Form, Input } from 'semantic-ui-react'
import {WindowURL,WindowLocation,WindowReload,RootURL,ImagesURL} from '../../config/settings'
export default function WebsiteFooter(props) {

	const [datenow, setdatenow] = useState(moment(new Date()).format('YYYY'));

	return (
    <React.Fragment>
		<div class="footer">
		  <div class="wrapper-grid">
		    <div class="footer-wrapper">
		      <div><p>Copyright © {datenow} <a href={RootURL('/')}>Gold Grup Limited/a>. All Rights Reserved.</p></div>
		      <div>
		        <span><a href={RootURL('/terms.php')}>Terms and Conditions</a></span> |
		        <span><a href={RootURL('/privacy-policy.php')}>Privacy Policy</a></span>
		      </div>
		    </div>
		  </div>
		</div>
    </React.Fragment>
	)
}
